<template>
  <div :class="$style.wrapper">
    <router-link
      v-for="doc in docs"
      :key="doc.label"
      :to="doc.to"
      :class="$style.docCard"
    >
      <span :class="$style.cardLeft">
        <span :class="$style.iconWrap">
          <img src="@/assets/img/account/doc.svg" alt="" />
        </span>
        <span>{{ doc.label }}</span>
      </span>
      <img src="@/assets/img/account/chev.svg" alt="" :class="$style.chev" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Docs",
  data() {
    return {
      docs: [
        {
          label: "Правила платформы SNKRROOM",
          to: "/docs/rules",
        },
        {
          label: "Политика обработки персональных данных",
          to: "/docs/personal-data",
        },
      ],
    }
  },
}
</script>

<style lang="scss" module>
.wrapper {
  padding: 1.25rem 1rem 6rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.docCard {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem 0.5rem 0.5rem;
  text-decoration: none;
  color: #111;
  border: 1px solid #ebeaea;
  border-radius: 0.75rem;
  background: #fff;
}

.cardLeft {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1rem;
  font-weight: 500;
}

.iconWrap {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.75rem;
  background: #f5f7fa;
  display: grid;
  place-items: center;
}

.iconWrap img {
  height: 100%;
}

.chev {
  width: 0.5rem;
  height: 0.75rem;
}
</style>
